import { Trans, useTranslation } from "react-i18next";

import { Stack, Typography } from "@mui/material";

import { AlertPanelBasic } from "../../../../alert-panel/AlertPanelBasic";
import { ExternalUrl } from "../../../../constants/externalUrls";
import { ExternalLink } from "../../../../external-link/ExternalLink";
import { AccordionKeys } from "../../../../utils/accordion-keys/AccordionKeys";

export function NoticeBox() {
  const { t } = useTranslation();

  return (
    <AlertPanelBasic
      severity="error"
      title={t("clients.client.debtSettlement.assetInventory.section1.noticeTitle")}
      storageKey={AccordionKeys.notice.assetInventory}
    >
      <Stack gap={0.5}>
        <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
          <Trans
            i18nKey="clients.client.debtSettlement.assetInventory.section1.noticeText"
            components={{ strong: <strong /> }}
          />
        </Typography>
        <ExternalLink
          href={ExternalUrl.LexikonVermoegensverzeichnis}
          variant="body2"
          aria-label={t("clients.client.debtSettlement.assetInventory.section1.glossaryLinkAria")}
          sx={{ alignSelf: "flex-start" }}
        >
          {t("clients.client.debtSettlement.assetInventory.section1.glossaryLink")}
        </ExternalLink>
      </Stack>
    </AlertPanelBasic>
  );
}
